import injectInk from './injectInk';
export default injectInk;



// WEBPACK FOOTER //
// ./src/js/Inks/index.js